import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import PdfViewer from "./PdfViewer";
import { useEffect } from "react";

export default function PDFDialogViewer({
  openPdfDialog,
  setOpenPdfDialog,
  pdfBlob,
}) {
  return (
    <Dialog
      open={openPdfDialog}
      onClose={() => {
        setOpenPdfDialog(false);
      }}
      fullWidth
      maxWidth="md"
    >
      <DialogContent>
        {pdfBlob && <PdfViewer pdfBlob={pdfBlob} />}
      </DialogContent>
      <DialogActions style={{ padding: "10px 25px" }}>
        <Button
          variant="contained"
          colors="primary"
          size="large"
          onClick={() => {
            setOpenPdfDialog(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 80,
            }}
          >
            <Typography>Затвори</Typography>
          </Box>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
